import { Text, TextProps, Link } from '@shopify/polaris';
import { IntercomClient } from '@/utils/IntercomClient';

type SupportLinkProps = Partial<TextProps>;

export const SupportLink = ({ as = 'span', ...rest }: SupportLinkProps) => {
  return (
    <Text as={as} {...rest}>
      If you need help, <Link onClick={() => IntercomClient.showChat()}>contact support</Link>.
    </Text>
  );
};

export default SupportLink;
